export const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export const UI_CONFIG = {
  MOBILE_BREAKPOINT: 768,
} as const;
